import Vue from 'vue';
import {XinTooltip} from '@xin/xin-ui';

export const expDirective = (store: any) => {
  Vue.directive('exp', {
    // <i class="icon icon-add22" v-exp :click="handlerAddQuickIn" exp-message="请联系客服激活此功能"></i>
    bind(el, binding, vnode: any) {
      // let isExp = store.getters.isExp
      function clickHandler(e: Event) {
        if (store.getters['moduleInfra/getIsExp']) {
          const {elm, data} = vnode;
          this._tooltip = XinTooltip({
            container: elm,
            content: data.attrs['exp-message'] || '请联系客服激活此功能',
            placement: data.attrs['placement'] || 'left'
          })
          el.addEventListener('mouseleave', this._tooltip.hide)
        } else {
          e.type == 'click' && vnode.data.attrs.click && vnode.data.attrs.click()
        }
      }

      if (binding.modifiers && binding.modifiers.hover) {
        el.addEventListener('mouseenter', clickHandler)
      }
      el.addEventListener('click', clickHandler)
    }
  })
}
